import React from 'react';

export interface ButtonFilterPropsInterface {
    children?: JSX.Element | Array<JSX.Element> | string;
}

export const ButtonFilter: React.FC<ButtonFilterPropsInterface> = ({ children }) => {
    return (
        <div className="sticky top-[120px] flex items-center overflow-auto whitespace-nowrap [&::-webkit-scrollbar]:hidden [&>*]:ml-xsmall [&>*:first-child]:ml-0">
            {children}
        </div>
    );
};
